import { render, staticRenderFns } from "./serverCell.vue?vue&type=template&id=5e0e36e0&scoped=true"
import script from "./serverCell.vue?vue&type=script&lang=js"
export * from "./serverCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e36e0",
  null
  
)

export default component.exports